import { defineStore } from 'pinia'

/** 支持的主题类型 */
export type ThemeMode = 'dark' | 'light'

const STORAGE_KEY = 'avgmaker-theme'

/**
 * 主题管理 Store
 *
 * 职责：
 * 1. 维护当前主题模式（dark / light）
 * 2. 在 `<html>` 元素上设置 `data-theme` 属性，驱动 CSS 变量切换
 * 3. 持久化用户选择到 `localStorage`
 */
export const useThemeStore = defineStore('theme', {
  state: () => ({
    /** 当前激活的主题 */
    mode: 'dark' as ThemeMode,
  }),
  actions: {
    /**
     * 初始化：从 localStorage 恢复主题，若无记录则默认 dark。
     * 应在 `app.mount()` 之前调用。
     */
    init() {
      const saved = localStorage.getItem(STORAGE_KEY) as ThemeMode | null
      this.mode = saved === 'light' ? 'light' : 'dark'
      this.applyToDocument()
    },

    /** 切换到指定主题 */
    setTheme(mode: ThemeMode) {
      this.mode = mode
      localStorage.setItem(STORAGE_KEY, mode)
      this.applyToDocument()
    },

    /** 在 dark / light 之间切换 */
    toggle() {
      this.setTheme(this.mode === 'dark' ? 'light' : 'dark')
    },

    /** 将主题属性写入 `<html>`，CSS 变量随之生效 */
    applyToDocument() {
      document.documentElement.setAttribute('data-theme', this.mode)
    },
  },
})
